export default __webpack_public_path__ + "static/media/whatsapp-banner.ff777d6c.png";